/* projects/shared/src/lib/components/custom-snack-bar/custom-snack-bar.component.css */
::ng-deep .cdk-overlay-container {
  z-index: 9999 !important;
}
/*# sourceMappingURL=custom-snack-bar.component.css.map */
